<template>
<div class="drawer">

    <v-navigation-drawer app v-model="droverMenu" class="h700" width="100%" hide-overlay>

        <div v-if="getTemplate" v-html="getTemplate.hb7" @click="edit(getTemplate.hb7, 'hb7')" class="isEdit">
        </div>
        <div class="row" style="width: 100%;padding-left: 1em; line-height: 1;">
            <div class="col-4" style="display: flex;
    align-self: center;">Выбор города: </div>
            <div class="col">
                <v-select v-model="currentCity" v-if="getCityList" :items="getCityList" item-text="name" item-value="domain" @change="changeCity" single-line dense></v-select>

            </div>
        </div>
        <button @click="droverMenu = !droverMenu" class="button-drower-close"> <i class="fas fa-times"></i> </button>
    </v-navigation-drawer>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
export default {
    data: () => ({
        droverMenu: false,
        currentCity: {},
    }),
    computed: mapGetters(["getTemplate", "getUser", "getCityList", "getHost"]),
    methods: {
        edit(code, block) {
            if (this.getUser) {
                this.$store.commit('setEditor', {
                    code: code,
                    block: block,
                    page: 'template'
                })
            }
        },
        changeCity() {
            window.location.href = 'http://' + this.currentCity;
        }
    },
    watch: {
        getCityList(val) {
            let host = val.filter(n => n.domain == this.getHost)[0];
            if (host) {
                this.currentCity = host
            } else {
                this.currentCity = val[0]
            }
        },
    }
};
</script>



// WEBPACK FOOTER //
// drower.vue?c7405e16